import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { LEGAL_NOTICES, LEGAL_NOTICES_VALIDATED } from 'actions/legalNotices';

const INITIAL_STATE = Immutable({
  status: 'idle', // idle, pending, validating, validated, error
  data: null as string | null,
  error: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${LEGAL_NOTICES}_LOADING`:
      return state.merge({ status: 'pending', error: null });
    case LEGAL_NOTICES:
      return state.merge({
        status: 'validating',
        data: action.payload,
        error: null,
      });
    case LEGAL_NOTICES_VALIDATED:
      return state.merge({
        status: action.payload.isValid ? 'validated' : 'error',
      });
    case `${LEGAL_NOTICES}_ERROR`:
      return state.merge({ status: 'error', data: '', error: action.payload });
    default:
      return state;
  }
};
